import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

type GetDataResponseHeaders = {
  "set-cookie"?: string | string[];
};

/** getData returns set-cookie as string[] when Rails sends multiple Set-Cookie lines. */
const setCookiesFromHeaders = (
  headers: GetDataResponseHeaders | undefined
): string[] => {
  const setCookieHeader = headers?.["set-cookie"];
  if (!setCookieHeader) return [];
  return Array.isArray(setCookieHeader) ? setCookieHeader : [setCookieHeader];
};

export const getAnonymousUserToken = async (
  baseUrl: string,
  config: object
): Promise<{ token: string; setCookies: string[] }> => {
  const queryPath = `${baseUrl}/token`;

  try {
    const response = await getData("", queryPath, {}, config);
    const data = (await deserialize(response.data)) as { token?: string };
    return {
      token: data?.token ?? "",
      setCookies: setCookiesFromHeaders(response.headers)
    };
  } catch (err) {
    throw new Error(err);
  }
};
